class DistributorNotAvailableError extends Error {
  constructor() {
    super(`The distributor is not available`)

    this.name = 'DistributorNotAvailableError'
  }
}

export default DistributorNotAvailableError
